import React, { createContext, useContext, useState, useEffect } from 'react';
import api, { setToken, clearToken } from '../lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("fb_token");
    if (token) {
      api.get("/auth/me")
        .then(r => setUser(r.data))
        .catch(() => { clearToken(); setUser(null); })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (credentials) => {
    const r = await api.post("/auth/login", credentials);
    setToken(r.data.access_token);
    setUser(r.data.user);
    return r.data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch(e) {}
    clearToken();
    setUser(null);
  };

  const register = async (data) => {
    const r = await api.post("/auth/register", data);
    return r.data;
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, register }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
